import React, { useEffect, useRef } from "react";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import "../css/cms-editor.css"
import { ListIcon } from "../../../../../asset-controller-mod/asset-serv/icons/iconExporter";

type CmsEditorProps = {
  value?: string;
  onChange?: (html: string) => void;
  placeholder?: string;
  minHeight?: number;
};

export default function CmsEditor({ //NOSONAR
  value = "",
  onChange,
  placeholder = "Write something…",
  minHeight = 160,
}: CmsEditorProps) {
  const isSettingFromOutside = useRef(false);

  const editor = useEditor({
    extensions: [StarterKit, Placeholder.configure({ placeholder })],
    content: value || "<p></p>",
    onUpdate: ({ editor }) => {
       /* istanbul ignore next */
      if (isSettingFromOutside.current) return;
      onChange?.(editor.getHTML());
    },
  });

  useEffect(() => {
    if (!editor) return;

    const next = value || "<p></p>";
    const current = editor.getHTML();

    if (next !== current) {
      isSettingFromOutside.current = true;
      editor.commands.setContent(next);
      queueMicrotask(() => {
        isSettingFromOutside.current = false;
      });
    }
  }, [value, editor]);

  if (!editor) return null;

  return (
    <div className="cms-editor" style={{ ["--minH" as any]: `${minHeight}px` }}>
      <div className="cms-editor__toolbar">
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleBold().run()}
          className={`bold-style-cmd ${editor.isActive("bold") ? "is-active" : ""}`}
        >
          B
        </button>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          className={`list-btn-style-cmd ${editor.isActive("bulletList") ? "is-active" : ""}`}
        >
          <ListIcon/>
        </button>

      </div>

      <EditorContent editor={editor} />
    </div>
  );
}